import {DashboardEffects} from './bdcdashboard/bdcdashboard.effects';
import {OpCodeEffects} from './opcode/opcode.effects';
import {SalesAvailabilityEffects} from './sales-availability/sales-availability.effects';
import {EmployeeEffects} from './employee/employee.effects';
import {HolidayEffects} from './holiday/holiday.effects';
import {CapacityEffects} from './capacity/capacity.effects';
import {TeamEffects} from './team/team.effects';
import {SlotEffects} from './slot/slot.effects';
import {SettingsEffects} from './settings/settings.effects';
import {SalesAppointmentEffects} from './sales-appointment/sales-appointment.effects';
import {PartsAppointmentEffects} from './parts-appointment/parts-appointment.effects';
import {ServiceAppointmentEffects} from './service-appointment/service-appointment.effects';
import {SearchCustomersEffects} from './search-customers/search-customers.effects';
import {DealerEffects} from './dealer/dealer.effects';
import {ScheduleRotationEffects} from './schedule-rotation/schedule-rotation.effects';
import { ScheduleDashboardEffects } from './schedule-dashboard/schedule-dashboard.effects';
import { VehiclesEffects } from './vehicle/vehicle.effects';
import { ChecklistEffects } from './checklist/checklist.effects';
import { DeliveryChecklistEffects } from './delivery-checklist/delivery-checklist.effects';
import { CorporateDashboardEffects } from './corporate-dashboard/corporate-dashboard.effects';

export const appEffects: any[] = [
  EmployeeEffects,
  HolidayEffects,
  CapacityEffects,
  TeamEffects,
  SettingsEffects,
  SlotEffects,
  SalesAvailabilityEffects,
  OpCodeEffects,
  SalesAppointmentEffects,
  PartsAppointmentEffects,
  ServiceAppointmentEffects,
  SearchCustomersEffects,
  DashboardEffects,
  DealerEffects,
  ScheduleRotationEffects,
  ScheduleDashboardEffects,
  VehiclesEffects,
  ChecklistEffects,
  DeliveryChecklistEffects,
  CorporateDashboardEffects
];
